<template>
  <div>
    <div class="app-title">
      <em-view-title :crudState="$_emCommonEditMixin_pathType"></em-view-title>
    </div>
    <section v-menu-permission="'edit'" class="app-content">
      <div class="card">
        <div class="card-body">
          <em-entity-edit-form ref="emEntityEditForm" :$_em-custom-vuex-mixin_entity="entityState"
                               :entity="modelName"
                               :return-path="returnPath"></em-entity-edit-form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// Author Lin
// Date 2021-06-28 10:31:33

import emCommonEditMixin from "@/mixin/em/common/edit";

export default {
  name: "sithMesInventoryPackageMaterialEditView",
  mixins: [emCommonEditMixin],
  computed: {
    modelName() {
      return this.$_emRouterHelperMixin_entityName
    },
    entityState() {
      return this.$route.query.hasOwnProperty('entityState') ? this.$route.query.entityState : 'entity';
    },
    returnPath() {

      // return "/sithMes/inventory/sithMesInventoryUnpackingList";
      // return "/sithMes/inventory/sithMesInventoryPackageMaterialList"

      let temp = this.$store.state.commonList.customVuexName;

      if (temp === "package") {
        return "/sithMes/inventory/sithMesInventoryPackageMaterialList"
      } else {
        return "/sithMes/inventory/sithMesInventoryUnpackingList";
      }

    },

  }
};
</script>